import { AccredibleButtonLoadingComponentModule } from '@accredible-frontend-v2/components/button-loading';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/components/icon';
import { AccredibleLanguageSelectorComponent } from '@accredible-frontend-v2/components/language-selector';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { EmailSentComponent } from './email-sent.component';

const MATERIAL_MODULES = [MatButtonModule, MatIconModule];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AccredibleButtonLoadingComponentModule,
    AccredibleIconComponentModule,
    AccredibleLanguageSelectorComponent,
    TranslocoModule,
    ...MATERIAL_MODULES,
  ],
  exports: [EmailSentComponent],
  declarations: [EmailSentComponent],
  providers: [],
})
export class EmailSentComponentModule {}
